var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import styled from 'styled-components';
export const GridContainerGutter = {
    xs: '0.75rem',
    s: '1.5rem',
    m: '2rem',
    l: '2rem',
    xl: '2.75rem'
};
export const GridItemGutter = {
    xs: '0.25rem',
    s: '0.5rem',
    m: '0.5rem',
    l: '0.5rem',
    xl: '0.75rem'
};
export const GridTotalColumns = 12;
const printWidthCss = (size) => {
    let str = '';
    for (let i = 1; i <= GridTotalColumns; i += 1) {
        str += `&.nds-${size}-${i} {width: calc(100% * ${i} / ${GridTotalColumns});}`;
    }
    return `${str}`;
};
const GridContainer = styled.div `
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
  width: 100%;
  padding: 0 ${GridContainerGutter.xs};

  @media (min-width: ${(props) => props.theme.SizeBreakpointsS}) {
    padding: 0 ${GridContainerGutter.s};
  }

  @media (min-width: ${(props) => props.theme.SizeBreakpointsM}) {
    padding: 0 ${GridContainerGutter.m};
  }

  @media (min-width: ${(props) => props.theme.SizeBreakpointsXl}) {
    padding: 0 ${GridContainerGutter.xl};
  }

  &._ndsGridCont--compact {
    padding: 0 !important;
  }
`;
const GridItem = styled.div `
  flex: 0 0 auto;
  box-sizing: border-box;
  width: 100%;
  padding: 0 ${GridItemGutter.xs};

  ${printWidthCss('xs')}

  @media (min-width: ${(props) => props.theme.SizeBreakpointsS}) {
    padding: 0 ${GridItemGutter.s};
    ${printWidthCss('s')}
  }

  @media (min-width: ${(props) => props.theme.SizeBreakpointsM}) {
    ${printWidthCss('m')}
  }

  @media (min-width: ${(props) => props.theme.SizeBreakpointsL}) {
    ${printWidthCss('l')}
  }

  @media (min-width: ${(props) => props.theme.SizeBreakpointsXl}) {
    padding: 0 ${GridItemGutter.xl};
    ${printWidthCss('xl')}
  }
`;
const Grid = (props) => {
    const { container, children, xs, s, m, l, xl, className: classNameProp, compact } = props, other = __rest(props, ["container", "children", "xs", "s", "m", "l", "xl", "className", "compact"]);
    if (container !== undefined) {
        const classNames = clsx(classNameProp, {
            '_ndsGridCont--compact': compact
        });
        return (React.createElement(GridContainer, Object.assign({ className: classNames }, other), children));
    }
    return (React.createElement(GridItem, Object.assign({ className: clsx(classNameProp, { [`nds-xs-${xs}`]: xs !== undefined }, { [`nds-s-${s}`]: s !== undefined }, { [`nds-m-${m}`]: m !== undefined }, { [`nds-l-${l}`]: l !== undefined }, { [`nds-xl-${xl}`]: xl !== undefined }) }, other), children));
};
Grid.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    container: PropTypes.bool,
    item: PropTypes.bool,
    className: PropTypes.string,
    xs: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
    s: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
    m: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
    l: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
    xl: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
    compact: PropTypes.bool
};
Grid.defaultProps = {
    children: null,
    container: undefined,
    item: true,
    className: null,
    xs: undefined,
    s: undefined,
    m: undefined,
    l: undefined,
    xl: undefined,
    compact: false
};
export default Grid;
//# sourceMappingURL=Grid.js.map